import React, { Component, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Platform from 'platform';
import keys from 'config/keys';
import scaleSize from '../utils/scale-size';
import { connect } from 'react-redux';
import EnterPinModal from 'components/Modal/EnterPin';
import { ConfirmModal, InfoModal, LoginModal, PendingModal } from 'components/Modal';
import PackageModal from 'components/Modal/PackageModal';
import { NotificationModal } from 'components/Modal/NotificationModal';
import { MODAL_TYPES } from 'constants/modal-types';
import PhoneModal from 'components/Modal/Phone';
import PortmoneModal from 'components/Modal/Portmone';
import LifecellPaymentModal from 'components/Modal/LifecellPaymentModal';

const ModalWrapper = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ transparent, theme }) =>
    transparent ? theme.transparentModalOverlayColor : theme.modalOverlayColor};
  z-index: 102;
`;

const MODAL_COMPONENTS = {
  [MODAL_TYPES.ENTER_PIN]: (props) => (
    <ModalWrapper transparent>
      <EnterPinModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.INFO]: (props) => (
    <ModalWrapper transparent>
      <InfoModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.CONFIRM]: (props) => (
    <ModalWrapper transparent>
      <ConfirmModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.LOGIN]: (props) => (
    <ModalWrapper transparent>
      <LoginModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.PACKAGE]: (props) => (
    <ModalWrapper transparent>
      <PackageModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.NOTIFICATION]: ({ transparent = true, ...rest }) => (
    <ModalWrapper transparent={transparent}>
      <NotificationModal {...rest} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.PENDING]: (props) => (
    <ModalWrapper transparent>
      <PendingModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.PHONE]: (props) => (
    <ModalWrapper transparent>
      <PhoneModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.PORTMONE]: (props) => (
    <ModalWrapper transparent>
      <PortmoneModal {...props} />
    </ModalWrapper>
  ),
  [MODAL_TYPES.LIFECELL_PAYMENT]: (props) => (
    <ModalWrapper transparent>
      <LifecellPaymentModal {...props} />
    </ModalWrapper>
  ),
};

const BackSupportHook = ({ backButtonKeyCode, onBack, children }) => {
  useEffect(() => {
    const onKeydown = (e) => {
      const { keyCode } = e;
      if (keyCode !== backButtonKeyCode) return;
      e.preventDefault();
      onBack();
    };
    document.addEventListener('keydown', onKeydown, true);
    return () => document.removeEventListener('keydown', onKeydown, true);
  });

  return children;
};

BackSupportHook.propTypes = {
  backButtonKeyCode: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired,
  children: PropTypes.element,
};

export class Modal extends Component {
  render() {
    const { modalType, modalProps, backButtonKeyCode } = this.props;
    if (!modalType) return null;

    const Modal = MODAL_COMPONENTS[modalType];

    return (
      <BackSupportHook backButtonKeyCode={backButtonKeyCode} onBack={modalProps.onModalBack}>
        <Modal {...modalProps} />
      </BackSupportHook>
    );
  }
}

const mapStateToProps = ({ modal }) => ({
  modalType: modal.modalType,
  modalProps: modal.modalProps,
  backButtonKeyCode: Platform.getKeyCode(keys.BACK),
});

export default connect(mapStateToProps, null)(Modal);
